<app-toast-message #toast toastKey="permission-groups"></app-toast-message>
<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="false"
  styleClass="generic-modal-container create-user-dialog"
  (onHide)="close()"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
>
  <ng-template pTemplate="header">
    <div class="modal-header">
      <h2>
        {{ editMode ? "Edit New Type Changes" : "Add a New Type Changes" }}
      </h2>
      <!-- Changed title -->
    </div>
  </ng-template>

  <div class="modal-body">
    <form [formGroup]="typeOfChangesForm" autocomplete="off">
      <!-- Changed formGroup name -->

      <div class="form-row">
        <div class="form-group">
          <label for="category">Category <span class="required">*</span></label>
          <p-dropdown
            [options]="category"
            optionLabel="name"
            [filter]="true"
            formControlName="category"
            placeholder="Select category"
            [appendTo]="'body'"
            [ngClass]="{
              'ng-invalid ng-dirty':
                typeOfChangesForm.controls['category'].invalid &&
                (typeOfChangesForm.controls['category'].touched ||
                  typeOfChangesForm.controls['category'].dirty)
            }"
          ></p-dropdown>
        </div>
        <div class="form-group">
          <label for="typeOfChanges"
            >Type of Changes <span class="required">*</span></label
          >
          <input
            id="typeOfChanges"
            type="text"
            pInputText
            placeholder="Enter type Of Changes"
            formControlName="typeOfChanges"
            [ngClass]="{
              'ng-invalid ng-dirty':
                typeOfChangesForm.controls['typeOfChanges'].invalid &&
                (typeOfChangesForm.controls['typeOfChanges'].touched ||
                  typeOfChangesForm.controls['typeOfChanges'].dirty)
            }"
          />
        </div>
      </div>
    </form>
  </div>

  <ng-template pTemplate="footer">
    <div class="footer-buttons">
      <button
        pButton
        type="button"
        label="Submit"
        class="p-button-warning"
        (click)="onSubmit()"
        [disabled]="!typeOfChangesForm.valid"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<app-modal
  [visible]="permissionPop"
  [cancelButtonText]="'No'"
  [submitButtonText]="'Yes'"
  [header]="'Permission'"
  (onSubmit)="onSubmitPermission($event)"
  (onCancel)="onCancelPermission($event)"
>
  <div class="permission-content">
    Are you sure you want to {{ this.editMode ? "edit" : "add" }} this Type of
    Changes
  </div>
</app-modal>
